export default __webpack_public_path__ + "static/media/sony.7b39fa8f.svg";